'use client';
import styles from './FloatButtons.module.scss';
import img from './assets/consultasProyment.png';
//import img from './assets/consultas.png';
//import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useWindowSize } from '../../hooks/getWindowSize';
import { numberPhone, whatsAppMessage } from '../../hooks/staticData';
import { useLocation } from 'react-router-dom';

export default function FloatButtons() {
  const size = useWindowSize(1024);
  const location = useLocation().pathname;
  const [bothMenu, setBothMenu] = useState({ menu1: true, menu2: true });
  const [stylePathname, setStylePathname] = useState(true);

  useEffect(() => {
    if (location !== '/agendar-reunion') {
      if (size.width > 767) {
        setStylePathname(true);
        if (bothMenu.menu1 && bothMenu.menu2) {
          //First Time render
          const timer = setTimeout(() => {
            const eCont = document.getElementById('consultasContainer');
            // Add your desired actions here
            eCont.style.display = 'flex';
            setTimeout(() => {
              const eIMG = document.getElementById('consultas');
              // Add your desired actions here
              eIMG.style.opacity = 1;
            }, 300);
          }, 4000);
          // Clean up the timer when the component unmounts
          return () => clearTimeout(timer);
        } else if (!bothMenu.menu1 && !bothMenu.menu2) {
          const e = document.getElementById('consultas');
          e.style.opacity = 0;
          const timer = setTimeout(() => {
            // Add your desired actions here
            const eCont = document.getElementById('consultasContainer');
            eCont.style.display = 'none';
          }, 400);
          // Clean up the timer when the component unmounts
          return () => clearTimeout(timer);
        } else {
          const eCont = document.getElementById('consultasContainer');
          eCont.style.display = 'flex';
          const timer = setTimeout(() => {
            // Add your desired actions here
            const e = document.getElementById('consultas');
            e.style.opacity = 1;
          }, 100);
          return () => clearTimeout(timer);
        }
      } else {
        setStylePathname(false);
      }
    } else {
      setStylePathname(false);
    }
  }, [bothMenu, size, location]);

  const handleClick = () => {
    window.location.href = `https://api.whatsapp.com/send?phone=${numberPhone}&text=${whatsAppMessage}`;
  };

  const handleMouseEnter = (menu) => {
    // Code to execute when the mouse enters the button
    setBothMenu((previousState) => {
      return { ...previousState, [menu]: true };
    });
  };

  const handleMouseLeave = (menu) => {
    // Code to execute when the mouse leaves the button
    setBothMenu((previousState) => {
      return { ...previousState, [menu]: false };
    });
  };

  return (
    <>
      <div
        style={stylePathname ? { display: 'flex' } : { display: 'none' }}
        className={styles.buttonContactContainer}
        id="buttonContactContainer"
      >
        <div
          id="consultasContainer"
          className={styles.consultas}
          onMouseEnter={() => handleMouseEnter('menu2')}
          onMouseLeave={() => handleMouseLeave('menu2')}
        >
          <button
            className={styles.btn}
            onClick={() => {
              handleClick();
            }}
          ></button>
          <img id="consultas" src={img} alt={'Consultas'} />
        </div>

        <button
          onClick={() => {
            handleClick();
          }}
          className={styles.buttonContact}
          onMouseEnter={() => handleMouseEnter('menu1')}
          onMouseLeave={() => handleMouseLeave('menu1')}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M14.3866 2.72464C18.1916 2.72464 21.2756 5.80864 21.2756 9.61364M14.3866 6.26464C16.2356 6.26464 17.7356 7.76364 17.7356 9.61364M9.60562 14.3646C10.5056 15.2276 11.5606 15.9296 12.7266 16.4276L13.2456 16.6486L14.8406 15.0286C15.2366 14.6266 15.8096 14.4526 16.3626 14.5686L20.2266 15.3776C20.8806 15.5166 21.3476 16.0936 21.3476 16.7616V19.5436C21.3476 20.5386 20.5416 21.3446 19.5466 21.3446H18.6916C14.7576 21.3446 10.8756 20.0416 7.93962 17.4236C7.69762 17.2086 7.46262 16.9856 7.23362 16.7576L7.27062 16.7946C7.04162 16.5656 6.81962 16.3306 6.60462 16.0886C3.98562 13.1536 2.68262 9.27164 2.68262 5.33764V4.48264C2.68262 3.48764 3.48862 2.68164 4.48362 2.68164L7.26562 2.68164C7.93362 2.68164 8.51062 3.14864 8.64962 3.80264L9.45962 7.66664C9.57462 8.21864 9.40162 8.79264 8.99962 9.18864L7.37962 10.7836L7.60062 11.3026C8.09862 12.4676 8.74162 13.4646 9.60562 14.3646Z"
              stroke="white"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <p>Agendar reunión</p>
        </button>
      </div>
      <div
        style={stylePathname ? { display: 'flex' } : { display: 'none' }}
        className={styles.buttonWhatsAppContainer}
      >
        <button
          onClick={() => {
            handleClick();
          }}
          className={styles.buttonWhatsApp}
        >
          <svg
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.0015 0C23.2857 0 30.0015 6.71572 30.0015 15C30.0015 23.2842 23.2857 30 15.0015 30C12.2506 30 9.67276 29.2596 7.45628 27.967L0.00773513 30L2.03568 22.5472C0.742405 20.3304 0.00146484 17.7517 0.00146484 15C0.00146484 6.71572 6.71719 0 15.0015 0ZM9.58847 7.96249C9.39439 7.97613 9.2041 8.02353 9.03085 8.11217C8.90088 8.17866 8.78022 8.27477 8.59063 8.45379C8.4116 8.62282 8.30785 8.77046 8.19853 8.91279C7.64398 9.6348 7.34593 10.5211 7.35147 11.4315C7.35448 12.1674 7.54564 12.8826 7.84753 13.5504C8.45972 14.9046 9.46931 16.3362 10.8029 17.6638C11.1232 17.9827 11.4371 18.3051 11.7755 18.603C13.4307 20.0604 15.4032 21.1113 17.536 21.6723C17.536 21.6723 18.376 21.8013 18.3883 21.8021C18.6666 21.8171 18.9444 21.7969 19.2229 21.7827C19.6599 21.7602 20.0865 21.642 20.4726 21.4363C20.7208 21.3042 20.8383 21.2385 21.0466 21.1071C21.0466 21.1071 21.1105 21.0639 21.2338 20.9721C21.4363 20.8212 21.5614 20.715 21.7299 20.5401C21.8541 20.4111 21.9609 20.2587 22.0434 20.087C22.1607 19.8421 22.2787 19.3749 22.3257 18.9869C22.3615 18.6905 22.3507 18.5285 22.3468 18.4281C22.3404 18.2667 22.207 18.1006 22.0609 18.0301L21.1887 17.6381C21.1887 17.6381 19.8844 17.0704 19.0867 16.7066C19.0036 16.6686 18.9127 16.6511 18.8214 16.6455C18.6213 16.6332 18.397 16.6854 18.2544 16.8357C18.2469 16.8327 18.1476 16.9185 17.0623 18.2332C17.0025 18.3048 16.8622 18.4604 16.6197 18.4458C16.5831 18.4433 16.5466 18.438 16.5111 18.4287C16.4128 18.4028 16.3171 18.3686 16.2235 18.329C16.038 18.2502 15.9729 18.2204 15.8461 18.1658C14.9802 17.7875 14.1855 17.2813 13.483 16.662C13.2946 16.4961 13.1194 16.3174 12.9388 16.1424C12.3085 15.5314 11.7925 14.8816 11.4087 14.2407C11.3877 14.2058 11.3554 14.1552 11.3206 14.0986C11.2578 13.9965 11.1885 13.875 11.1668 13.7916C11.1111 13.5709 11.259 13.3937 11.259 13.3937C11.259 13.3937 11.6241 12.9945 11.7937 12.7775C11.9569 12.5685 12.0978 12.3642 12.1875 12.2186C12.3642 11.9345 12.4201 11.6409 12.3273 11.4144C11.9065 10.3885 11.4723 9.36804 11.0248 8.35341C10.9365 8.15318 10.6738 8.00769 10.4349 7.9801C10.354 7.97076 10.2731 7.96137 10.1919 7.95603C9.99079 7.94622 9.78929 7.94838 9.58847 7.96249Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
    </>
  );
}
